import api from './client';

// Public APIs
export const getProjects = async (category = null, featured = null) => {
  const params = {};
  if (category) params.category = category;
  if (featured !== null) params.featured = featured;
  
  const response = await api.get('/projects', { params });
  return response.data;
};

export const getProject = async (id) => {
  const response = await api.get(`/projects/${id}`);
  return response.data;
};

export const getProjectBySlug = async (slug) => {
  const response = await api.get(`/projects/by-slug/${encodeURIComponent(slug)}`);
  return response.data;
};

export const submitContact = async (data) => {
  const response = await api.post('/contact', data);
  return response.data;
};

export const getSettings = async () => {
  const response = await api.get('/settings');
  return response.data;
};

// Admin APIs
export const adminLogin = async (username, password) => {
  const response = await api.post('/admin/login', { username, password });
  return response.data;
};

export const getCurrentAdmin = async () => {
  const response = await api.get('/admin/me');
  return response.data;
};

export const getAdminProjects = async () => {
  const response = await api.get('/admin/projects');
  return response.data;
};

export const createProject = async (data) => {
  const response = await api.post('/admin/projects', data);
  return response.data;
};

export const updateProject = async (id, data) => {
  const response = await api.put(`/admin/projects/${id}`, data);
  return response.data;
};

export const deleteProject = async (id) => {
  const response = await api.delete(`/admin/projects/${id}`);
  return response.data;
};

export const reorderProjects = async (items) => {
  // items: [{id, order}, ...]
  const response = await api.put('/admin/projects/reorder', { items });
  return response.data;
};

export const trackCtaEvent = async (variant, type) => {
  try {
    await api.post('/cta/event', { variant, type });
  } catch (e) {
    // swallow — analytics should never break UX
  }
};

export const getCtaStats = async () => {
  const response = await api.get('/admin/cta/stats');
  return response.data;
};

export const trackVcardDownload = async () => {
  try {
    await api.post('/vcard/download');
  } catch (e) {
    // swallow — analytics should never break UX
  }
};

export const getVcardStats = async () => {
  const response = await api.get('/admin/vcard/stats');
  return response.data;
};

export const getStockAudit = async () => {
  const response = await api.get('/admin/projects/stock-audit');
  return response.data;
};

export const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  
  const response = await api.post('/admin/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getContacts = async () => {
  const response = await api.get('/admin/contacts');
  return response.data;
};

export const updateContactStatus = async (id, status) => {
  const response = await api.patch(`/admin/contacts/${id}`, null, {
    params: { status },
  });
  return response.data;
};

export const deleteContact = async (id) => {
  const response = await api.delete(`/admin/contacts/${id}`);
  return response.data;
};

export const getAdminSettings = async () => {
  const response = await api.get('/admin/settings');
  return response.data;
};

export const updateAdminSettings = async (data) => {
  const response = await api.put('/admin/settings', data);
  return response.data;
};

export const changeAdminPassword = async (current_password, new_password) => {
  const response = await api.post('/admin/change-password', {
    current_password,
    new_password,
  });
  return response.data;
};

export const requestPasswordReset = async (email) => {
  const response = await api.post('/admin/forgot-password', { email });
  return response.data;
};

export const resetAdminPassword = async (token, new_password) => {
  const response = await api.post('/admin/reset-password', { token, new_password });
  return response.data;
};
